import { Colors } from '@microfrontends/react-components'
import styled from 'styled-components'
import { bgColorTopNumerology } from './const'

export const H3 = styled.h3`
	font-weight: 700;
	font-size: 40px;
	line-height: 50px;
	letter-spacing: -0.06em;
	color: ${Colors.info};
	text-align: center;
	margin: 0;
	margin-bottom: 8px;
	@media screen and (max-width: 767px) {
		margin-bottom: 4px;
		font-size: 32px;
		line-height: 40px;
	}
	span {
		color: ${Colors.text};
	}
`

export const ArticleCss = styled.div`
	margin-bottom: 24px;
	@media screen and (max-width: 767px) {
		margin-bottom: 16px;
	}
	.section__article {
		background: #fff;
		padding: 24px 0;
		&-title {
			font-weight: 700;
		}
		&-item {
			display: flex;
			flex-direction: column;
			gap: 8px;
			border: 1px solid #f5f5f5;
			color: ${Colors.text};

			padding: 8px;
			border-radius: 6px;
			width: 100%;
			height: auto;
			&:hover {
				border: 1px solid ${Colors.button};
				.info {
					&__title {
						color: ${Colors.button};
					}
				}
			}
			.thumb {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				&__iamge {
					border: 8px solid #fff !important;
					border-radius: 50%;
					&:hover {
						border: 8px solid #c3d8ff !important;
					}
				}
			}
			.info {
				display: flex;
				flex-direction: column;
				gap: 4px;
				&__title {
					font-weight: 600 !important;
					font-size: 15px;
					line-height: 18px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3; /* number of lines to show */
					line-clamp: 3;
					-webkit-box-orient: vertical;
					height: calc(3 * 18px);
				}
				p {
					margin-bottom: 0;
					font-weight: 400;
					line-height: 18px;
				}
				&__description {
					font-size: 14px;
					line-height: 18px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3; /* number of lines to show */
					line-clamp: 3;
					-webkit-box-orient: vertical;
					height: calc(3 * 18px);
				}
				&__created-at {
					font-size: 13px;
					color: ${Colors.textGray};
				}
			}
		}
	}
`
export const CelebritiesCss = styled.div`
	background-color: #ebf2ff;
	width: 100%;
	overflow: unset;
	margin-bottom: 24px;
	.section__celebrities {
		position: relative;
		padding: 24px 59px;
		&-title {
			font-weight: 700;
			margin-bottom: 16px;
			@media screen and (max-width: 767px) {
				margin-bottom: 12px;
			}
		}
		&-item {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			gap: 8px;
			width: 100%;
			height: auto;
			opacity: 1;
			.avatar {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				&__iamge {
					border: 8px solid #fff !important;
					border-radius: 50%;
					&:hover {
						border: 8px solid #c3d8ff !important;
					}
				}
			}
			.info {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				gap: 4px;
				p {
					margin-bottom: 0;
				}
				&__name {
					font-weight: 700;
					font-size: 16px;
					line-height: 22px;
				}
				&__job-title {
					font-weight: 500;
					font-size: 15px;
					line-height: 20px;
					text-align: center;
					height: calc(2 * 20px);
				}
				&__ruling-number {
					color: ${Colors.button};
					font-weight: 800;
					font-size: 17px;
					line-height: 22px;
				}
			}
		}
		.slider-wrap {
			width: 100%;
			position: static;
		}
	}

	@media screen and (max-width: 767px) {
		margin-bottom: 16px;
	}
	@media all and (max-width: 576px) {
		overflow: hidden;
		min-height: 420px;
		.section__celebrities {
			padding: 16px 0;

			.slider-wrap {
				width: 150vw;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
			}
			&-item {
				opacity: 0.25;
			}
			.slider__item-active {
				.section__celebrities-item {
					opacity: 1;
				}
				.avatar {
					&__iamge {
						border: 8px solid #c3d8ff !important;
					}
				}
			}
		}
	}
`
export const RulingNumberSliderCss = styled.div`
	width: 100%;
	user-select: none;
	.section {
		background-color: ${bgColorTopNumerology};
		.section__slider {
			transition: none !important;
			transition: scale 0.25s ease-in-out;
			&-active {
				.section__slider-item {
					transform: scale(1.2);
					opacity: 1;
				}
			}
			&-item {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				opacity: 0.25;
				transform: scale(0.7);
				/* transition: scale 0.25s ease-in-out; */
				user-select: none;
				/* &.active {
					transform: scale(1.2);
					opacity: 1;
				} */
			}
		}
	}
	@media all and (max-width: 576px) {
		.section {
			position: fixed;
			width: 100%;
			top: 0;
			left: 0;
			z-index: 0;
		}
	}
`
export const RulingNumberSliderV2Css = styled.div`
	min-height: 200px;
	display: flex;
	align-items: center;
	opacity: 0;
	&.visible {
		opacity: 1;
	}
	.section__slider-item {
		pointer-events: none;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
		opacity: 0.3;
		> div {
			height: 80px;
			width: 80px;
			span {
				font-size: 3rem;
			}
		}
	}
	.section__slider-active {
		.section__slider-item {
			opacity: 1;
			> div {
				height: 115px;
				min-width: 115px;
				background: #ffc947;
				border: 1px solid #ffffff;
				backdrop-filter: blur(5px);
				color: ${Colors.primary};
				text-shadow: 0px 2px 0px ${Colors.button};
				span {
					font-size: 4rem;
				}
				.circle {
					width: 130px;
					height: 70px;
					position: absolute;
					visibility: visible;
				}
			}
		}
	}
	@media screen and (min-width: 769px) {
		.section__slider-item {
			display: flex;
			align-items: center;
			justify-content: center;
			> div {
				height: 90px;
				width: 90px;
			}
		}
		.section__slider-active {
			.section__slider-item {
				opacity: 1;
				> div {
					height: 155px;
					width: 155px;
					span {
						font-size: 5.5rem;
					}
					.circle {
						width: 190px;
						height: 90px;
					}
				}
			}
		}
		div.section__slider-active + div .section__slider-item {
			justify-content: end;
			opacity: 0.5;
			> div {
				height: 125px;
				width: 125px;
				span {
					font-size: 4.2rem;
				}
			}
		}
		div:has(+ div.section__slider-active) {
			.section__slider-item {
				justify-content: start;
				opacity: 0.5;
				> div {
					height: 125px;
					width: 125px;
					span {
						font-size: 4.2rem;
					}
				}
			}
		}
	}
`
export const ContentBoxCss = styled.div`
	.section__content {
		background: #fff;
		border-radius: 12px;
		padding: 32px;
		p {
			margin-bottom: 0;
		}
	}

	@media all and (max-width: 768px) {
		.section__content {
			padding: 24px 12px 12px 12px;
			border-radius: 0;
			margin: 0 -12px;
		}
		.mrtop {
			margin-top: 280px;
		}
	}
`
export const ChartNumerologyCss = styled.div`
	.section__chart {
		background: rgba(0, 23, 68, 0.03);
		border-radius: 12px;
		padding: 24px 32px;
		display: flex;
		flex-direction: column;
		gap: 24px;
		&-des {
			margin-bottom: 0;
			text-align: left;
			span {
				font-weight: 600;
			}
			.ruling-number {
				color: ${Colors.button} !important;
			}
		}
		&-wrap {
			padding: 32px 0 16px 0;

			.label__chart {
				&-title {
					font-weight: 600;
					font-size: 16px;
					line-height: 26px;
					margin-bottom: 8px;
					text-align: left;
				}
				.item {
					display: flex;
					align-items: center;
					gap: 10px;
					justify-content: space-between;
					&__info {
						width: 80%;
						display: flex;
						align-items: center;
						gap: 8px;
						&-color {
							min-width: 20px;
							height: 20px;
							border-radius: 4px;
						}
					}
					&__percent {
						width: 20%;
					}
				}
			}
		}
		&-title {
			font-weight: 700;
		}
		@media all and (max-width: 768px) {
			padding: 24px 16px;
			.canvas__chart {
				width: 100%;
				justify-content: center;
				display: flex;
			}
			&-des {
				text-align: center;
			}
			&-wrap {
				padding: 0;
				justify-content: center;
				.label__chart {
					width: 100%;
					&-title {
						text-align: center;
					}
				}
			}
		}
	}
`
export const CommonNumerologyCss = styled.div`
	.section__common {
		padding: 24px 32px;
		gap: 16px;
		background: #fff;
		border-radius: 12px;
		&.mr-bottom {
			margin-bottom: -16px;
		}
		&-content {
			p {
				margin-bottom: 0;
			}
			ul {
				margin: 0;
				padding: 0;
				li {
					span {
						font-weight: 600;
					}
				}
			}
		}

		@media all and (max-width: 768px) {
			border-radius: 0;
			padding: 16px 0;
			background-color: unset;
			border-top: 1px solid #eaeaf0;
			&.mr-bottom {
				margin-bottom: 0;
			}
		}
	}
`

export const FixedBottomButtonCss = styled.div`
	background: #fff;
	border-top: 1px solid #eaeaf0;
	border-bottom: 1px solid #eaeaf0;
	padding: 24px;
	width: 100%;
	.button__fixed {
		width: 100%;
	}
`
interface IWrapProps {
	bgColor: string
	marginBottom?: string
	noPd?: boolean
}
export const WrapWithBgCss = styled.div<IWrapProps>`
	background-color: ${(props) => (props.bgColor ? props.bgColor : undefined)};
	margin-bottom: ${(props) =>
		props.marginBottom ? props.marginBottom : undefined};
	.--container {
		padding: ${(props) => (props.noPd === true ? 0 : undefined)};
	}
	.section {
		padding: 0;
	}
`
export const ContentWrapCss = styled.div`
	ul {
		list-style: initial;
	}
`
